import { useNavigate } from 'react-router-dom';

import {
    DefaultModalsKeys,
    ModalsProvider,
} from '@speeki/global-ui-components';

import { getPath, Paths } from '@services/RouteService/paths';

interface HandleModalRedirectValues {
    modalName: keyof DefaultModalsKeys;
    path: Paths;
}

export const useModalRedirect = () => {
    const navigate = useNavigate();

    const handleModalRedirect = ({
        modalName,
        path,
    }: HandleModalRedirectValues) => {
        navigate(getPath({ path }));
        ModalsProvider.close(modalName);
    };

    return {
        handleModalRedirect,
    };
};
